import { P, Particles, Rng, type FxMeta } from "pixelfx";

/** Пыль от падения на пол: мягкие клубы катятся в обе стороны и тают. Без колец — читается как пыль, не как разметка. */
export const meta: FxMeta & { options: Record<string, unknown> } = {
  name: "Dust landing",
  duration: 1.6,
  loop: false,
  fps: 30,
  size: [96, 40],
  origin: [48, 36],
  options: { seed: 1, count: 16 },
};

interface DustOptions {
  seed: number;
  count: number;
}

const DUST = 0x9a8a8278;

export function create(options: DustOptions): { update(dt: number): void; draw(painter: unknown): void } {
  const random = new Rng(options.seed);
  const particles = new Particles({ rng: random, ground: () => 0 });
  for (let index = 0; index < options.count; index++) {
    const side = index % 2 === 0 ? 1 : -1;
    particles.spawn(
      P.DUST ?? 0,
      side * random.range(2, 8),
      -1,
      side * random.range(25, 70),
      random.range(-18, -4),
      random.range(0.6, 1.3),
      DUST,
      random.range(2, 4),
    );
  }
  return {
    update(dt: number): void {
      particles.update(dt);
    },
    draw(painter: unknown): void {
      particles.draw(painter);
    },
  };
}
